import { DrawerMenuItemList } from 'Components/Layout/DrawerMenu/DrawerMenuItemList'
import type { NavLink } from 'Components/Layout/DrawerMenu/types'
import StyledDrawer from 'Components/StyledDrawer'
import { isPtaBannerVisible } from 'Services/common/Features/Authority/Context/utils'
import useTypedSelector from 'Store'
import type { FC } from 'react'
import { useLocation } from 'react-router-dom'

const DrawerMenu: FC<{ drawerMenuNavLinks: NavLink[]; rootUrl: string }> = ({
  drawerMenuNavLinks,
  rootUrl
}) => {
  const location = useLocation()
  const { user } = useTypedSelector(state => state.user)
  return (
    <StyledDrawer
      isPtaBannerVisible={isPtaBannerVisible(user, location)}
      variant="permanent"
      open={true}
    >
      <DrawerMenuItemList navLinks={drawerMenuNavLinks} rootUrl={rootUrl} />
    </StyledDrawer>
  )
}

export { DrawerMenu }
